import { lazy } from 'react';

const AuditLogs = lazy(() => import('../../views/AuditLogs/index'));

const AuditLogsRoutes = [
    {
        path: '/audit-logs',
        element: <AuditLogs />
    }
];

export default AuditLogsRoutes;
